export { VFile } from './lib/index.js';